import { render, staticRenderFns } from "./bpreportitem.vue?vue&type=template&id=d84bd872&"
import script from "./bpreportitem.vue?vue&type=script&lang=js&"
export * from "./bpreportitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports